import { render, staticRenderFns } from "./DialogAiAssistance.vue?vue&type=template&id=1124e701"
import script from "./DialogAiAssistance.vue?vue&type=script&lang=js"
export * from "./DialogAiAssistance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports